import React, { useState, useEffect } from 'react';
import "./styles.css";

/**
 * @function UICheckbox
 * @param {STRING} className - Additional classes to add to the UICheckbox.
 * @param {STRING} value - Allows us to set a value to the checkbox.
 * @param {STRING} label - This is the label to the left of the checkbox.
 * @return {React.Component}
 * @exported true
 * @description This is a checkbox with a label to the left of it and an border on the bottom.
 * @example
 * <UICheckbox className="added-class" value="true" label="Option 1" />
 */
export default function UICheckbox(props) {
  const className = props.className ?? "";
  const label = props.label ?? "";
  const onChange = props.onChange ?? function(){ return undefined; };

  const [ state, setState ] = useState(props.value ?? false);
  useEffect(() => setState(props.value ?? false), [ props.value ]);

  return (
    <div className={className + " ui-checkbox"}>
      <label className="flex-container align-center-container">
        <span className="flex-width">{label}</span>
        <input className="set-width" type="checkbox" checked={ state } onChange={ onChange } />
      </label>
    </div>
  );
}